module.exports = __webpack_public_path__ + "img/deo_logo.54c05d0e.png";